// Based on ContentOptimizationStep#as_json in Ruby
// ContentOptimizationStep < MessageStep, adds only optimization_conversion_config

import { z } from "zod";
import { contentOptimizationPhaseSchema } from "@schemas/shared/contentOptimizationPhaseSchema";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const contentOptimizationStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("CONTENT_OPTIMIZATION"),
  step_data: z.never().optional(),
  // ContentOptimization-specific field added via as_json
  // Always present in response (from .merge() in as_json), but can be null when behavior not set
  optimization_conversion_config: z
    .object({
      event_type: z.enum(["TrackedUserBehavior::CanvasOpen", "TrackedUserBehavior::CanvasClick"]),
      performed_behavior_window_in_seconds: z.int().min(0),
      conversion_links: z.array(z.string()).optional(),
    })
    .nullable(),
  optimization_phase: contentOptimizationPhaseSchema.nullable().optional(),
});
